import { Button, Select, useTheme } from '@ytl/common-web';
import { AxiosError } from 'axios';
import { KeyboardEvent, useCallback, useState } from 'react';
import { useLanguage } from '../contexts/languageContext';
import { useOpenAm } from '../contexts/openAmContext';
import { OpenAmAuthenticateError } from '../shared/@types/OpenAmInitialData';
import { StageFailureType } from '../shared/@types/OpenAmStage';
import { useOpenAmStage } from '../shared/services/useOpenAmStage';
import { LoginAnalytics } from '../shared/utils/analytics';

export const SmsNumberSelectorStage = () => {
  const { translation } = useLanguage();
  const { loginWithPhoneNumber } = useOpenAmStage();
  const { isWebView } = useTheme();
  const { isLoading, initParams, stage } = useOpenAm();
  const [error, setError] = useState('');
  const [phoneNumber, setPhoneNumber] = useState<{ value: string; label: string } | null>(null);
  const parsed = JSON.parse(stage.infoText?.at(0) || '{}');
  const options = parsed.phoneNumbers.split('|').map((number: string) => ({
    value: number,
    //label: '06' + number.substring(0, 2) + ' ' + number.substring(2, 6) + ' ' + number.substring(6, number.length),
    //Jira OAT-43 kérésre 0620 1332 843 helyett 20 133 2843 stílusban fog látszani a CTN választóban
    label: number.substring(0, 2) + ' ' + number.substring(2, 5) + ' ' + number.substring(5, number.length),
  }));

  const handleEdit = useCallback((e: KeyboardEvent) => {
    if (!['Escape', 'ArrowUp', 'ArrowDown', 'Tab', 'ShiftTab', 'Enter'].includes(e.code)) {
      e.preventDefault();
    }
  }, []);

  const sendPhoneNumber = useCallback(async () => {
    if (phoneNumber?.value) {
      try {
        await loginWithPhoneNumber(phoneNumber.value, (failure, isMfa) => {
          if (
            failure.stagefailure === StageFailureType.SubscriptioncheckSubscription ||
            failure.stagefailure === StageFailureType.SmsInvalidPhoneNumber
          ) {
            LoginAnalytics.loginFailure(isWebView, 'sms', isMfa, failure.stagefailure);
            setError(translation.loginRegister.login.box.loginError.subscriptionCheckError(initParams?.faqLink || '#'));
          }
        });
      } catch (err) {
        if ((err as AxiosError).isAxiosError) {
          const axiosError = err as OpenAmAuthenticateError;
          if (axiosError.response?.data?.message === StageFailureType.SubscriptioncheckSubscription) {
            LoginAnalytics.loginFailure(isWebView, 'sms', false, StageFailureType.SubscriptioncheckSubscription);
            setError(translation.loginRegister.login.box.loginError.subscriptionCheckError(initParams?.faqLink || '#'));
            return;
          }
        }
        LoginAnalytics.loginFailure(isWebView, 'sms', false, 'error-sms-phonenumber');
        setError(translation.loginRegister.login.box.loginError.general);
      }
    }
  }, [phoneNumber, loginWithPhoneNumber, setError, translation, isWebView, initParams]);

  return (
    <>
      <h3>{translation.loginRegister.login.mfa.selector.header}</h3>

      <div>{translation.loginRegister.login.mfa.selector.subHeader}</div>
      <div>
        <Select
          options={options}
          label={
            <>
              {translation.loginRegister.login.mfa.selector.selectLabel}
              {/*translation.accountSettings.mfa.setup.mfaTypeLabel*/}
              {/*<Tooltip*/}
              {/*  html={translation.accountSettings.mfa.setup.mfaTypeLabelTooltip}*/}
              {/*  icon={<InfoIcon className={'icon icon--tooltip'} />}*/}
              {/*  includeIconInTooltip={true}*/}
              {/*/>*/}
            </>
          }
          name="phone-number"
          onChange={e => {
            setPhoneNumber(e);
          }}
          value={phoneNumber}
          isLoading={false}
          onKeyDown={handleEdit}
          placeholder={'Válassz a számok közül'}
        />
      </div>

      {error && (
        <div
          className="login-page__container__error"
          dangerouslySetInnerHTML={{ __html: error }}
        ></div>
      )}

      <Button
        variant={'contained'}
        onClick={sendPhoneNumber}
        disabled={isLoading || !phoneNumber}
      >
        {translation.loginRegister.login.mfa.selector.buttonLabel}
      </Button>
    </>
  );
};
